import React from "react";
import Chart from "../../Chart";
import ExampleGauge from "../../../../components/Chart/ExampleGauge";

class GaugeExampleApplet extends Chart {

    render() {
        return <ExampleGauge applet={this}
                          attributes={this.state.Attributes}
                          value={this.state.Value}
                          sx={this.state.sx}
                          enterpriseComponent={this.getEnterpriseComponent()} />;
    }

    state = {
        Name: "GaugeExampleApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        Attributes: {
            Height: 300,
            ValueMin: 0,
            ValueMax: 100,
            StartAngle: -110,
            EndAngle: 110,
        },
        Value: 0,
    }
}

export default GaugeExampleApplet;
